import { v4 as uuid } from 'uuid';
import {
  NavItem, StyledFlexContainer, StyledImage,
} from './styled';

export const Navigation = ({ setIsOpen, routes}) => routes.map((item)=> (
  <StyledFlexContainer onClick={() => setIsOpen(false)} key={uuid()}>
    <StyledImage src={item.icon} alt={item.routeName} />
    <NavItem to={item.route}>{item.routeName}</NavItem>
  </StyledFlexContainer>
));
